import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Confidentialite() {
  return (
    <div className="bg-white min-h-screen py-24 px-6 md:px-12">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center text-sm text-slate-600 hover:text-spi-blue">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Retour à l'accueil
        </Link>
        <h1 className="mt-8 font-display text-4xl text-spi-blue font-bold">
          Politique de confidentialité
        </h1>

        <div className="mt-10 text-slate-700 space-y-6">
          <p>
            La présente politique décrit comment Swiss Premium Insurance collecte,
            utilise et protège vos données personnelles, conformément à la
            <strong> Loi fédérale sur la protection des données (LPD)</strong> suisse
            et au <strong>Règlement général sur la protection des données (RGPD)</strong>
            de l'Union européenne.
          </p>

          <section>
            <h2 className="font-display text-xl text-spi-blue font-semibold mt-8">1. Responsable du traitement</h2>
            <p>
              Swiss Premium Insurance — contact@sp-insurance.ch
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-spi-blue font-semibold mt-8">2. Données collectées</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Données d'identification&nbsp;: prénom, nom, adresse</li>
              <li>Données de contact&nbsp;: email, téléphone</li>
              <li>Données fournies dans le simulateur&nbsp;: situation familiale, revenus, fortune (non nominatives)</li>
              <li>Données techniques&nbsp;: cookies strictement nécessaires</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl text-spi-blue font-semibold mt-8">3. Finalités</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Traiter votre demande de contact et vous recontacter</li>
              <li>Calculer une estimation indicative de subsides</li>
              <li>Respecter nos obligations légales et réglementaires (LSA, LCA)</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl text-spi-blue font-semibold mt-8">4. Base légale</h2>
            <p>
              Votre <strong>consentement explicite</strong> (case à cocher du formulaire) ainsi
              que l'<strong>exécution de mesures précontractuelles</strong> à votre demande.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-spi-blue font-semibold mt-8">5. Durée de conservation</h2>
            <p>
              Les données du formulaire de contact sont conservées 3 ans après le dernier
              échange. Les données comptables et contractuelles obligatoires sont
              conservées 10 ans conformément au Code des obligations suisse.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-spi-blue font-semibold mt-8">6. Destinataires</h2>
            <p>
              Vos données ne sont jamais cédées ni vendues à des tiers. Elles peuvent être
              transmises aux compagnies d'assurance uniquement avec votre accord explicite,
              dans le cadre de la souscription d'un contrat.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-spi-blue font-semibold mt-8">7. Vos droits</h2>
            <p>Vous disposez à tout moment des droits suivants&nbsp;:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Droit d'accès à vos données</li>
              <li>Droit de rectification</li>
              <li>Droit à l'effacement</li>
              <li>Droit d'opposition et de retrait du consentement</li>
              <li>Droit à la portabilité</li>
            </ul>
            <p>Pour exercer ces droits&nbsp;: contact@sp-insurance.ch</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-spi-blue font-semibold mt-8">8. Cookies & analytics</h2>
            <p>
              Nous utilisons des cookies strictement nécessaires au fonctionnement du site
              et, sous réserve de votre consentement explicite via le bandeau cookies,
              des cookies de mesure d'audience anonymisés (Google Analytics 4).
              Aucun cookie publicitaire ou de profilage n'est déposé sans votre accord.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-spi-blue font-semibold mt-8">9. Sécurité</h2>
            <p>
              Les échanges sont chiffrés via HTTPS/TLS. Les données sont stockées sur des
              serveurs sécurisés avec accès restreint aux personnes habilitées.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-spi-blue font-semibold mt-8">10. Indépendance</h2>
            <p>
              Service privé indépendant sans lien avec les administrations publiques.
              La demande officielle de subside peut être déposée de manière autonome
              et gratuite auprès de votre organisme cantonal compétent.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
